import {zoom as zoomView} from "../operations/zoom";

export function zoom(value, page){
	zoomView(this, value, false, page);
}